import { Box } from '@mui/material'
import React, { useEffect, useState } from 'react'
import NotificationItem from 'src/Libs/notifications/components/modals/NotificationItem'
import NotificationPagination from 'src/Libs/notifications/components/modals/NotificationPagination'
import { ShopPopupMessage } from '../models/shop-popup-message.model'

interface Props {
  messages: ShopPopupMessage[]
  title: string
  onMarkMessageAsRead: (contentHash: string) => void
}

/*
 * Composes the portal notification item and paginator for shop messages.
 */
const ShopPopupMessageModalContent: React.FC<Props> = ({ messages, title, onMarkMessageAsRead }) => {
  const [currentMessageIndex, setCurrentMessageIndex] = useState(0)
  const safeMessageIndex = Math.min(currentMessageIndex, Math.max(messages.length - 1, 0))
  const currentMessage = messages[safeMessageIndex]

  useEffect(() => {
    if (currentMessageIndex !== safeMessageIndex) setCurrentMessageIndex(safeMessageIndex)
  }, [currentMessageIndex, safeMessageIndex])

  if (!currentMessage) return null

  return (
    <Box>
      <NotificationItem
        id={safeMessageIndex}
        text={currentMessage.message}
        startAt={null}
        title={title}
        sxStyle={{ marginTop: 4 }}
        onMarkNotificationsAsRead={() => onMarkMessageAsRead(currentMessage.contentHash)}
      />
      <NotificationPagination
        currentPage={safeMessageIndex + 1}
        lastPage={messages.length}
        setPage={setCurrentMessageIndex}
        sxStyle={{ marginTop: 1 }}
      />
    </Box>
  )
}

export default ShopPopupMessageModalContent
